import './00-jwplayer';
import SSPresentationDisplayer from './01-slideshare_presentation_displayer'
import SSBandInteraction from './00-slideshare_band_interaction'
import SSToolbar from './01-slideshare_toolbar'
import SSPresentationSlide from './01-slideshare_presentation_slide'
import SSLastScreen from './00-slideshare_lastscreen'
import PlayerModalShare from '../share/player_modal_share'
import SSTouchInteraction from './00-slideshare_touch_interaction'
import SSDocumentDisplayer from './01-slideshare_document_displayer'
import SSDocumentSlide from './01-slideshare_document_slide'
import SSInfographicDisplayer from './01-slideshare_infographic_displayer'
import SSInfographicSlide from './01-slideshare_infographic_slide'
import SSReplayScreen from './00-slideshare_replayscreen';
import SSVideoEmbedSlide from './01-slideshare_video_slide'
import SSMetaResource from './001-slideshare_meta_resource'
import SSFontResource from './001-slideshare_font_resource'
import SSVideoDisplayer from './01-slideshare_video_displayer';
import SSIframeDisplayer from './01-slideshare_iframe_displayer';
import SSVideoBar from './00-slideshare_video_bar';
import SSIframeSlide from './01-slideshare_iframe_slide';
import { isIos } from '../mobile/02-mobile_devices';
import { isIEAllVersion } from './03-slideshare_player';

export const isMobile = function () {
  var isMobile = navigator.userAgent.match(
    /iPhone|iPad|iPod|Android|BlackBerry|IEMobile|webOS|Mobile|Windows Phone/i
  );
  return isMobile;
};

/* Container model for the player */
/* This caches all resources for the player */
function SSPlayerController(config) {
  if (typeof config === 'undefined') {
    return;
  }
  this.config = config;

  this.realSlideCount = this.config.slide_count;
  this.slideCount = this.realSlideCount;
  if (this.config.has_video) {
    this.slideCount += this.config.video_slides_count;
  }
  delete this.config.slide_count;
  this.mode = this.config.mode;

  // use image mode if both html and image conversion exist
  if (this.config.show_image_player && this.config.mode === 'html') {
    this.mode = 'image';
  }

  this.config.disable_meta = this.config.show_image_player ? true : false;
  delete this.config.mode;
  this.currentPosition = 0;

  // @todo Move these to load_queue class
  // loadingSlides is used to preload slides in anticipation if no loads are happening
  this.loadingSlides = []; // array of slide numbers
  this.loadedSlides = [];

  this.slideModes = {};
  this.availableBgSizes = {};
  this.availableFallbackSizes = {};

  this.PRELOAD_PRE_LIMIT = 2;
  this.PRELOAD_POST_LIMIT = 5;
  this.FONT_BATCH_COUNT = 10;
  this.DEFAULT_ERROR_SCORE = 0;
  this.AUTOVERIFICATION_ERROR_THRESHOLD = 0.001;

  this.AUTOVERIFICATION_THRESHOLDS = {
    'bad v1.0': 0.001,
    'bad v1.1': 0.0001,
    'bad v2.0': 0.0001,
  };

  this.MAX_PERCENTAGE_FAILING = {
    'bad v1.0': 100,
    'bad v1.1': 20,
    'bad v2.0': 20,
  };

  this.isEmbed = this.config.hosted_in === 'embed';
  if (this.isEmbed) {
    this.TOOLBAR_HEIGHT = 58;
  } else {
    this.TOOLBAR_HEIGHT = 50;
  }

  this.MULTIMEDIABAR_HEIGHT = 25;
  if (this.config.show_image_player) {
    this.MULTIMEDIABAR_HEIGHT = 29;
  }

  this.initialized = false;
  this.PRERENDER_COUNT = 1;

  this._init();
  this.startSlide = parseInt(this.config.start_slide || 1, 10);
  this.play(this.startSlide);
  this.config.actionButtonsContainer = $(
    '#svPlayerId .action-btns-container, #player .action-btns-container'
  );
}

SSPlayerController.prototype._init = function () {
  var that = this,
    mode,
    // Set up the ClickGen tracker to monitor link impressions and clicks
    ClickGenTracker = slideshare_object.utils.imports(
      'tracking.ClickGenTracker'
    );
  this.clickGenTracker = new ClickGenTracker();
  // Passing along controller's render_links config to the tracker so that events
  // are only fired if links are enabled, i.e they are rendered.
  this.clickGenTracker.renderAllLinks = this.config.render_links === 'all';

  $.slideshareEventManager.registerController(this);
  $.slideshareEventManager.registerEnvironment(this.config.hosted_in);
  this.cachedDomElements = {};
  this.componentSets = {};
  mode = this._isFullScreen() ? 'fullscreen' : 'normal';
  this._createComponentSet(mode);
  this.isNativeFullScreenSupported = this._isNativeFullScreenSupported();
  this._bindEvents();
  this.exitFullScreenHandler = this.exitFullScreenHandlerFactory();
  if (this.mode !== 'video') {
    if (!this.config.disable_meta || !this.config.show_image_player) {
      this._initMetadata();
      this._loadMetadata();
    } else {
      this.conversionVersion = 2;
      this.slideSizes = {};

      this.slideLinks = {};
      this.postInitialize();
    }
  } else {
    this.VIDEO_REINITIALISE_TIME = 100;
    this.VIDEO_FULLSCREEN_ZINDEX = 100;
    this._loadVideoMeta();
  }

  $(document).trigger('slideshare-player-controller:init-done');

  $.slideshareEventManager.trackEvent('player_initialized', true);

  if (this.config.next_prev_experiment) {
    // If this page load is from sunpass, fire an event
    if (this.config.next_slideshow_pos) {
      $.slideshareEventManager.trackEvent('next_slideshow_cta_page_load');
    }

    // Hide existing seen next slideshows
    var ssIds = window.cookie('next_slideshows_seen_ids');
    if (ssIds) {
      ssIds = ssIds.split(',');
      this.config.ssIds = ssIds;
      if (ssIds && ssIds[0] !== '') {
        for (var i = 0, j = ssIds.length; i < j; i++) {
          $(
            '.j-related-more-tab .j-related-item a[data-ssid="' +
              ssIds[i] +
              '"]'
          ).hide();
        }
      }
    }
  }

  $(window).on('keyup', function (e) {
    // user has pressed space
    if (e.keyCode == 32) {
      var $player = $('.player');
      var isFullscreen =
        window.innerWidth == $player.width() &&
        window.innerHeight == $player.height();
      if (isFullscreen) {
        $.slideshareEventManager.trigger('next', { source: 'spacebar_next' });
      }
    }
  });

  // Set image dimensions on document ready
  $(document).ready(function() {
    var initialSlideIndex = that.startSlide - 1 
    var $slides = $('.slide_image');
    var $startSlide = $slides.eq(initialSlideIndex);

    // Hide while loading
    $startSlide.hide();

    $startSlide.on('load', function () {
      var naturalWidth = $startSlide.prop('naturalWidth');
      var naturalHeight = $startSlide.prop('naturalHeight');
      
      $slides.css('max-width', naturalWidth + 'px');
      $slides.css('max-height', naturalHeight + 'px');

      $startSlide.show();
    })

    that._load(initialSlideIndex);
  });
};

SSPlayerController.prototype._loadVideoMeta = function () {
  if (this.config.is_private) {
    this._getHtmlSignatures();
  }
  this.initialized = true;
};

SSPlayerController.prototype._initMetadata = function () {
  if (this.mode === 'html') {
    if (this.config.is_private) {
      this._getHtmlSignatures();
    }
    this._initFontResources();
    this._initHtmlMetadata();
    // Init image meta for fall back
    this.config.image_ready && this._initImageMetadata(true);
  } else if (this.mode === 'image') {
    this._initImageMetadata();
  } else {
    if (window._gaq) {
      _gaq.push([
        '_trackEvent',
        'jsplayer',
        'invalidplayermode',
        this.config.id,
      ]);
    }
    throw 'Unknown player mode';
  }
};

SSPlayerController.prototype._loadMetadata = function () {
  if (this.mode === 'html') {
    this.metaResource.load();
    this.config.image_ready && this.imageMetaResource.load();
  } else if (this.mode === 'image') {
    this.imageMetaResource.load();
  } else {
    throw 'Unknown player mode';
  }
};

SSPlayerController.prototype._initHtmlMetadata = function (signature) {
  this.metaResource = new SSMetaResource({
    url: this.config.bucket_location + 'meta.js',
    timestamp: this.config.timestamp,
    type: 'html',
    is_private: this.config.is_private,
    signature: signature,
  });
};

SSPlayerController.prototype._initImageMetadata = function (
  isFallback,
  signature
) {
  this.imageMetaResource = new SSMetaResource({
    url: this.config.image_bucket_location + '/meta.js',
    timestamp: this.config.timestamp,
    type: isFallback ? 'imagefallback' : 'imageprimary',
  });
};

SSPlayerController.prototype._initFontResources = function (
  signatures,
  fontBatchCount
) {
  var userAgent = navigator.userAgent.toLowerCase();
  var fontBatchNum;
  if (fontBatchCount) {
    fontBatchNum = Math.ceil(this.slideCount / fontBatchCount);
  } else {
    fontBatchNum = Math.ceil(this.slideCount / this.FONT_BATCH_COUNT);
  }
  var urlSuffix;
  if (/msie/.test(userAgent) && !/opera/.test(userAgent)) {
    urlSuffix = this.config.html_eotfont_url_suffix;
  } else {
    urlSuffix = this.config.html_ttffont_url_suffix;
  }
  var i;
  this.fontResources = [];
  for (i = 1; i <= fontBatchNum; i++) {
    this.fontResources[i] = new SSFontResource({
      baseUrl: this.config.bucket_location,
      indexString: this._getIndexString(i, 0),
      timestamp: this.config.timestamp,
      suffix: urlSuffix,
    });
  }
};

SSPlayerController.prototype.getImagePrivateSignatures = function (
  imageSizes,
  mode
) {
  var that = this;
  (function (mode) {
    $.ajax({
      url: that.config.images_signature_request_route,
      data: {
        id: that.config.id,
        key: that.config.secret_key,
        mode: mode,
        images_sizes: imageSizes,
        version: that.conversionVersion,
        password_hash: that.config.password_hash,
        authenticity_token: window._auth_token,
      },
      dataType: 'json',
      cache: false,
      type: 'POST',
      success: function (data) {
        if (mode === 'html') {
          that.privateImageSignatures = data;
        } else if (mode === 'image') {
          that.privateFallBackImageSignatures = data;
        }
        if (mode === 'html' || mode === 'image') {
          that.postInitialize();
        } else {
          //For html with fallback
          if (that.slidesCreated) {
            var imageCount = that.slideModes.image.length;
            var slide, slideIndex;
            for (var i = 0; i < imageCount; i++) {
              slideIndex = that.slideModes.image[i];
              slide = that.slides[that.realIndexToIndex[slideIndex]];
              slide.resources.image.addSignature(data[slideIndex]);
              slide.resources.image.ready();
            }
          } else {
            that.privateFallBackImageSignatures = data;
          }
        }
      },
    });
  })(mode);
};

SSPlayerController.prototype._getHtmlSignatures = function () {
  var policyUrl = this.config.signature_request_route;
  var that = this;
  $.ajax({
    url: policyUrl,
    data: { id: this.config.id, key: this.config.secret_key },
    dataType: 'json',
    cache: false,
    type: 'GET',
    success: function (data) {
      var dataLength = data.length;
      var dataObj;
      if (dataLength !== 0) {
        for (var i = 0; i < dataLength; i++) {
          dataObj = data[i];
          that.htmlResourceSignatures = data[i].info;
        }
        for (i = 0; i < that.slideCount; i++) {
          if (that.slides && that.slides[i]) {
            const slide = that.slides[i];
            slide.resources.html.updateSignature(
              that.htmlResourceSignatures[i].url
            );
            slide.resources.html.ready();
          }
        }
      } //if
    },
    failure: function () {
      $.slideshareEventManager.trigger('metadataloadfailed', {
        type: that.config.type,
      });
    },
  });
};

SSPlayerController.prototype._metaDataHandlers = function () {
  var criticalFailureHandler = function () {
    var height, width;
    var slidedisplayer = this.currentComponentSet.slidedisplayer;
    height = slidedisplayer.container.height();
    width = slidedisplayer.container.width();

    slidedisplayer.error(
      this.generateErrorDom('meta_error_template', {
        width: width,
        height: height,
      })
    );
    $('#playerFacade').hide();
  };

  return {
    html: {
      success: function (data) {
        this.conversionVersion = parseInt(data.version || 2, 10);

        this.slideSizes = data.sizes || {};
        var availableSizes = {};
        this.availableBgSizes = data.available_sizes || {};

        // some content might not have error scores.
        // Also we are using webkit error data across all browsers now
        var errorScores = data.error_scores || {};
        this.algo = errorScores.algo || 'bad v1.0';
        this.errorScores = errorScores.webkit || {};

        var commonStyle =
          '\n.ssml_div span {line-height:normal;} ' +
          '\n.ssml_div div {line-height:normal;}\n.ssml_div{font-size:16px;}';

        if (this.config.render_links === 'none') {
          commonStyle = commonStyle + '\n.ssml_div a{cursor:default;}';
        }

        var defaultPresentationStyle =
          'a.ssml_a {text-decoration:none;color:inherit;vertical-align:top;} ' +
          '\n.ssml_div span {position:absolute; white-space:pre; vertical-align:top;} ' +
          '\n.ssml_div div {position:absolute;}';
        var finalResetStyleTag =
          '<style>' +
          (data.global_styles_css || defaultPresentationStyle) +
          commonStyle +
          '</style>';

        $(finalResetStyleTag).appendTo(this.currentComponentSet.container);

        if (data.pages_per_fontfile) {
          this.FONT_BATCH_COUNT = data.pages_per_fontfile;
          this._initFontResources();
        }
        if (this.config.is_private) {
          this.getImagePrivateSignatures(this.availableBgSizes, 'html');
        } else {
          this.postInitialize();
        }
      },
      failure: criticalFailureHandler,
    },
    imagefallback: {
      success: function (data) {
        if (this.config.render_links === 'none') {
          data.links = {}; // disabling links for pinterest
        }
        if (this.slidesCreated) {
          this.fallbackMetaHandler(data);
        } else {
          this.fallbackMetaData = data;
        }
      },
      failure: function () {
        var imageCount = this.slideModes.image.length;
        var i, width, height, slideIndex, slide;

        for (i = 0; i < imageCount; i++) {
          slideIndex = this.slideModes.image[i];
          slide = this.slides[slideIndex];
          // We do not know sizes, we do not know which version the conversion was done in. #fail
          width = slide.currentViewMode.width;
          height = slide.currentViewMode.height;

          slide.displayError(
            this.generateErrorDom('slide_error_template', {
              width: width,
              height: height,
            }),
            true
          );
        }
      },
    },
    imageprimary: {
      success: function (data) {
        this.conversionVersion = parseInt(data.version || 2, 10);
        this.slideSizes = data.sizes || {};

        if (this.config.render_links === 'none') {
          data.links = {}; // disabling links for pinterest
        }

        this.slideLinks = data.links || {};

        var slideCount = this.realSlideCount;
        var i, slideAvailableSizes, dimensions;
        this.availableFallbackSizes = data.available_sizes;
        if (this.config.is_private) {
          this.getImagePrivateSignatures(this.availableFallbackSizes, 'image');
        } else {
          this.postInitialize();
        }
      },
      failure: criticalFailureHandler,
    },
  };
};

SSPlayerController.prototype.fallbackMetaHandler = function (data) {
  var conversionVersion = parseInt(data.version || 2, 10);
  var imageSizes = data.sizes || {};

  // image factory v2 changes have available sizes
  var availableSizes = data.available_sizes || {};
  var imageLinks = data.links || {};
  var imageCount = this.slideModes.image.length;
  var slideAvailableSizes, dimensions, slide;

  for (var i = 0; i < imageCount; i++) {
    const slideIndex = this.slideModes.image[i];
    dimensions = imageSizes[slideIndex] || {};

    // new change. this should slide to initialized state and execute any queued load events
    slideAvailableSizes = availableSizes[slideIndex];
    //  delete(availableSizes[slideIndex]);
    if (slideAvailableSizes === undefined) {
      slideAvailableSizes = { 320: [75], 768: [75] };
      slideAvailableSizes[dimensions.width] = [75];
      // @todo - this will break max size image's url generation if size of content is less than 768.
      // go back and fix
    }

    slide = this.slides[this.realIndexToIndex[slideIndex]];
    slide.setContentDimensions(dimensions.width || 0, dimensions.height || 0);
    slide.updateResource('image', {
      sizes: {
        contentWidth: dimensions.width || 0,
        availableSizes: slideAvailableSizes,
        conversionVersion: conversionVersion,
        is_private: this.config.is_private,
      },
      linkData: imageLinks[slideIndex] || [], //verify structure is valid
    });
  }
  if (this.config.is_private) {
    this.getImagePrivateSignatures(availableSizes, 'imagefb');
  }
};

SSPlayerController.prototype.postInitialize = function () {
  this._initSlides();
  // @todo combine next two calls into one
  this._activateComponentSet(this.currentViewMode);
  this._setModeForSlides(this.currentViewMode);
  this.setDimensions();
  $(this).trigger('playerinitialized');
  try {
    if (window.parent.infographic_campaign) {
      $.slideshareEventManager.trigger('viewfullscreen');
    }
  } catch (err) {}
};

SSPlayerController.prototype.initVideoPlayer = function (mode) {
  this.multimediaResource = this.currentComponentSet.videobar;
  this.multimediaResource.videoPlayer = window.jwplayer('videoSlideContainer_' + mode);
  this._activateComponentSet(mode);
  this.setDimensions();
  $('[id*=videoSlideContainer]').css('cursor', 'default');
};

SSPlayerController.prototype._bindEvents = function () {
  var that = this;

  $(this).bind('playerinitialized', function () {
    this.initialized = true;
    that.play();
  });
  if (this.config.preload_after_pageload) {
    $(window).bind('load', function () {
      that.pageLoadFired = true;
    });
  }

  if (!(this.config.touch || this.config.player_type === 'video')) {
    // @todo move this to a keyboard interaction class
    $(document).bind('keyup', function (e) {
      if (e.target.nodeName !== 'INPUT' && e.target.nodeName !== 'TEXTAREA') {
        if (e.keyCode === 37) {
          if (that.currentComponentSet.lastScreen) {
            that.currentComponentSet.lastScreen.destroy();
          }
          $.slideshareEventManager.trigger('previous');
        }
        if (e.keyCode === 39) {
          $.slideshareEventManager.trigger('next');
        }
      }
    });
  }
  if (this.isNativeFullScreenSupported) {
    $(document).bind(
      this.nativeFullScreen.fullScreenChangeEventName(),
      function (e) {
        that._nativeFullScreenHandler.call(that, e);
      }
    );
  }
};

SSPlayerController.prototype._bindComponentSetEvents = function () {
  var that = this;
  var componentSet = this.currentComponentSet;
  // document player, while scrolling fires slidechanged events when the browser changes slide automatically.
  // When a slidechanged is received from the displayer, we want to update ui components to update themself
  // Refactor later to use observer model.

  $(componentSet.slidedisplayer).bind('zoomchanged', function (e) {
    that.repaint();

    if (this.documentSlider) {
      var i = 1;
      while (i < that.slides.length) {
        if (
          typeof that.slides[i].currentViewMode.imageElement === 'undefined'
        ) {
          break;
        }
        // Is this slide the wrong size? If so, we must redraw it.
        if (
          that.currentComponentSet.slidedisplayer.slidesContainer.width() !==
          that.slides[i].currentViewMode.imageElement.width()
        ) {
          // Force it to be redrawn
          that.slides[i].show(true);
        }
        i++;
      }
    }
  });
};

SSPlayerController.prototype._createComponentSet = function (mode) {
  // this function creates the child objects like displayer, toolbar, scrollbars and also touch interactions

  var that = this;
  this.componentSets[mode] = {};
  this.currentComponentSet = this.componentSets[mode];
  this.currentViewMode = mode;
  var componentSet = this.currentComponentSet;

  if (mode === 'normal' || this.config.show_image_player) {
    componentSet.container = $('#' + this.config.container);
    if (componentSet.container.length !== 1) {
      throw 'Unable to find container for player';
    }
  } else if (mode === 'fullscreen') {
    // create a div here
    this.normalModeScrollPosition = $(window).scrollTop();
    componentSet.container = $('<div/>')
      .addClass('jsplInpageFullScreen')
      .appendTo($('body'));
    $('body, html').css({ overflow: 'hidden' });
  }

  var isFullScreen = this._isFullScreen(mode);
  var componentBackgroundColor = this._getPlayerBgColor(mode);

  componentSet.navigators = []; // array of navigator interactions

  var displayerConfig = {
    renderTo: componentSet.container,
    spinnerUrl: this.config.spinner_url,
    errorImageUrl: this.config.error_image_url,
    mode: this.mode,
    slideCount: this.slideCount,
    playerType: this.config.player_type,
    playerBgColor: componentBackgroundColor,
    hosted_in: this.config.hosted_in,
    show_image_player: this.config.show_image_player,
  };

  if (this.config.player_type === 'html') {
    displayerConfig.iframe_id = this.config.iframe_id;
  }

  if (this._isFullScreen(mode)) {
    displayerConfig.spinnerUrl = this.config.spinner_url_fullscreen;
  }
  if (this.config.player_type === 'document') {
    componentSet.slidedisplayer = new SSDocumentDisplayer(displayerConfig);
  } else if (this.config.player_type === 'video') {
    this.videoSpecialSettings = this.getSpecialSettingsForVideo();
    displayerConfig.videoBucket = this.config.video_bucket;
    displayerConfig.pptLocation = this.config.ppt_location;
    displayerConfig.screenMode = mode;
    displayerConfig.videoSpinner = this.config.video_spinner_location;
    displayerConfig.playerDomName = this.config.container;
    displayerConfig.videoExtension = this.config.video_extension;
    displayerConfig.useDefaultToolbar =
      this.videoSpecialSettings.defaultToolbar;
    displayerConfig.ieAndLessThan8 = this.videoSpecialSettings.ieLT8;
    displayerConfig.swfLocation = this.config.swf_location;
    displayerConfig.playIcon = this.config.video_play_icon;
    displayerConfig.posterImage = this.config.poster_img_url;
    displayerConfig.embedOnIe = this.isEmbedAndIE();
    displayerConfig.isEmbed = this.config.hosted_in === 'embed';
    displayerConfig.autoplayOnEmbed = this.config.autoplayOnEmbed;
    this.hasToolbar = !this.videoSpecialSettings.defaultToolbar;
    displayerConfig.isMobileDevice = this.config.touch;
    displayerConfig.isMobileAndNonIos =
      this.config.touch && !navigator.userAgent.match(/(iPhone|iPad|iPod)/i);
    componentSet.slidedisplayer = new SSVideoDisplayer(displayerConfig);
  } else if (this.config.player_type === 'infographic') {
    displayerConfig.isMobileDevice = this.config.touch;
    componentSet.slidedisplayer = new SSInfographicDisplayer(displayerConfig);
  } else if (this.config.player_type === 'html') {
    displayerConfig.isMobileDevice = this.config.touch;
    componentSet.slidedisplayer = new SSIframeDisplayer(displayerConfig);
  } else {
    displayerConfig.isTouch = this.config.touch;
    componentSet.slidedisplayer = new SSPresentationDisplayer(
      displayerConfig
    );
  }

  /* no toolbar for mobile */
  this.hasToolbar =
    !this.config.touch || this.config.hosted_in !== 'mobile_slideview';

  componentSet.navigators.push(componentSet.slidedisplayer);
  this.setDimensions();

  var componentSetWidth = this.currentComponentSet.width;
  var componentSetHeight = this.currentComponentSet.height;

  this.config.shareScreenClass = '';
  this.config.lastScreenClass = '';
  this.config.showProLastScreen = true;

  // Hack for diplaying last screen and share screen on large enough embeds
  if (this.config.hosted_in !== 'mobile_slideview') {
    if (!this.config.disable_share) {
      this.config.shareScreenClass = this._getShareScreenClass(
        componentSetWidth,
        componentSetHeight
      );
    }
    if (this.config.hosted_in !== 'slideview') {
      this.config.lastScreenClass = this._getLastScreenClass(
        componentSetWidth,
        componentSetHeight
      );
    }
    this.config.showProLastScreen = this.canShowProLastScreen(
      componentSetWidth,
      componentSetHeight
    );
  }

  if (this.config.touch) {
    componentSet.touchInteraction = new SSTouchInteraction({
      container: componentSet.slidedisplayer.container,
      playerType: this.config.player_type,
      hostedIn: this.config.hosted_in,
    });
    componentSet.navigators.push(componentSet.touchInteraction);
  } else if (this.config.player_type === 'presentation' && !isMobile()) {
    var is_disable_links = this.config.render_links === 'none';
    componentSet.bandInteraction = new SSBandInteraction({
      container: componentSet.slidedisplayer.container,
      width: componentSet.width,
      linksDisabled: is_disable_links,
    });
    componentSet.navigators.push(componentSet.bandInteraction);
  }

  if (this.hasToolbar) {
    var toolbarConfig = {
      width: componentSet.width,
      height: this.TOOLBAR_HEIGHT,
      html: this.config.toolbar_html,
      renderTo: componentSet.container,
      totalSlideCount: this.slideCount,
      primaryResourceType: this.config.primaryResourceType,
      disableShare: this.config.disable_share,
      disableFullScreen: this.config.disable_full_screen,
      enableViewSS: this.config.enable_viewSS,
      isFullScreen: isFullScreen,
      playerType: this.config.player_type,
      enableZoomButtons: this.config.player_type == 'document',
      show_image_player: this.config.show_image_player,
      isEmbed: this.config.hosted_in !== 'slideview',
      isFlagged: this.config.flagging && this.config.flagging.is_flagged,
      player_type: this.config.player_type,
    };
    var player_type = this.config.player_type;
    if (player_type === 'infographic' || player_type === 'html') {
      var config = {
        disableNav: true,
        disableGoToSlide: true,
        disableShare: false,
        enableViewSS: true,
        enableZoomButtons: false,
        disableFullScreen: false,
        disableLeaveFullScreen: false,
        buttonOverrides: {},
        elementOverrides: {},
      };
      if (this.config.hosted_in == 'slideview') {
        config.enableViewSS = false;
        config.disableFullScreen = false;
        config.disableLeaveFullScreen = false;
        config.enableZoomButtons = false;
        var buttonOverrides = config.buttonOverrides;
        buttonOverrides.btnFullScreen = '.btnFullScreen';
        config.elementOverrides.fullScreen = '.btnFullScreen';
      }
      if (this.config.hosted_in == 'slideshare') {
        config.enableViewSS = false;
      }
      $.extend(toolbarConfig, config);
    }
    componentSet.toolbar = new SSToolbar(toolbarConfig);
    componentSet.navigators.push(componentSet.toolbar);
  }

  if (this.config.player_type === 'video') {
    if (!componentSet.toolbar) {
      componentSet.toolbar = $('<div/>');
    }
    componentSet.videobar = new SSVideoBar({
      renderTo: componentSet.toolbar.container,
      height: this.MULTIMEDIABAR_HEIGHT,
      html: this.config.multimediabar_html,
      isMobileDevice: this.config.touch,
    });
    componentSet.navigators.push(componentSet.videobar);
    this.multimediaResource = componentSet.videobar;
  }

  if (this.config.has_video) {
    componentSet.videoConfetti = $('<img/>')
      .attr({
        src: this.config.confetti_url,
      })
      .css({
        position: 'absolute',
        top: '-1px',
        left: '-1px',
      })
      .appendTo(componentSet.container.find('.stage'));
  }

  if (!this.config.disable_share) {
    $('.j-action-share').click(function (e) {
      e.preventDefault();
      e.stopPropagation();
      $.slideshareEventManager.trigger('playershare', 'share_btn_');
    });
  }

  if (this.mode !== 'video') {
    this._bindComponentSetEvents();
  }
};

SSPlayerController.prototype.configureComponentsForNativeMode = function (
  mode
) {
  var componentSet = this.currentComponentSet;

  componentSet.slidedisplayer.refresh({
    spinnerUrl: this.config.spinner_url_fullscreen,
  });
  componentSet.toolbar.config.isFullScreen = this._isFullScreen(mode);
  componentSet.toolbar._initForNativeFullScreen(mode);
};

SSPlayerController.prototype._isFullScreen = function (mode) {
  return (
    mode === 'fullscreen' ||
    mode === 'nativefullscreen' ||
    this.config.is_fullscreen
  );
};

SSPlayerController.prototype._getPlayerBgColor = function (mode) {
  var isFullScreen = this._isFullScreen(mode);
  var componentBackgroundColor = 'jsplBgColorBigfoot'; // default background color
  if (isFullScreen) {
    componentBackgroundColor = this.config.fullscreen_bgcolor;
  } else {
    componentBackgroundColor = this.config.player_bgcolor;
  }
  return componentBackgroundColor;
};

SSPlayerController.prototype._getShareScreenClass = function (
  componentSetWidth,
  componentSetHeight
) {
  var shareScreenClass = null;

  if (componentSetWidth > 360 && componentSetHeight > 260) {
    shareScreenClass = 'normal';
  } else if (componentSetWidth > 320 && componentSetHeight > 250) {
    shareScreenClass = 'small';
  } else if (componentSetWidth > 290 && componentSetHeight > 280) {
    shareScreenClass = 'tiny';
  }
  return shareScreenClass;
};

SSPlayerController.prototype.canShowProLastScreen = function (
  componentSetWidth,
  componentSetHeight
) {
  if (componentSetWidth < 337 || componentSetHeight < 142) {
    return false;
  }
  return true;
};

SSPlayerController.prototype._getLastScreenClass = function (
  componentSetWidth,
  componentSetHeight
) {
  var lastScreenClass = 'small';

  if (componentSetWidth >= 512 && componentSetHeight >= 421) {
    lastScreenClass = 'medium';
  } else if (componentSetWidth >= 427 && componentSetHeight >= 356) {
    lastScreenClass = 'normal';
  }
  return lastScreenClass;
};

SSPlayerController.prototype._destroyComponentSet = function (mode) {
  var componentSet = this.componentSets[mode];
  $.each(componentSet.navigators, function (i, navigatorItem) {
    navigatorItem.destroy();
  });
  delete this.componentSets[mode].navigators;
  delete this.componentSets[mode].slidedisplayer;
  if (mode === 'fullscreen') {
    componentSet.container.remove();
    $('body, html').css({ overflow: 'auto' });
  }
  var slide;
  if (this.slides) {
    for (var i = 1; i <= this.slideCount; i++) {
      slide = this.slides[i];
      slide.viewModes[mode].container.remove();
      delete slide.viewModes[mode];
    }
  }
  delete this.componentSets[mode].container;
  delete this.componentSets[mode];
};

/**
 * Maps the real slide number to the virtual slide number.
 * virtual slide number is same as real slide number when there are no videos
 * in the presentation.
 * In case of videos, slide number maps to the real slide number
 * The real slide number gives us the representation of the presentation slides
 * for which resources are tied to their actual index.
 */
SSPlayerController.prototype._mapIndexes = function () {
  var videoSlidesHash = this.config.video_hash;

  var realSlidePosition = 1; // start index from 1
  var totalSlides = this.slideCount;
  var slideToRealIndexMap = {},
    realIndexToIndexMap = {};

  for (var i = 1; i <= totalSlides; i++) {
    if (videoSlidesHash && videoSlidesHash[i]) {
      slideToRealIndexMap[i] = null; //setting to null in case of video, helps in detecting it
    } else {
      slideToRealIndexMap[i] = realSlidePosition;
      // Adjusted Index to Real Index map.
      realIndexToIndexMap[realSlidePosition] = i;
      // Real Index to adjusted index map.
      realSlidePosition++;
    }
  }

  this.indexToRealIndex = slideToRealIndexMap;
  this.realIndexToIndex = realIndexToIndexMap;
};

SSPlayerController.prototype._percentageFailing = function (errorThreshold) {
  var slidesFailing = 0;

  for (var i in this.errorScores) {
    if (this.errorScores[i] > errorThreshold) {
      slidesFailing++;
    }
  }
  if (this.slideCount === 0) {
    return 0;
  }

  return parseInt(100 * (slidesFailing / this.slideCount), 10);
};

SSPlayerController.prototype._initSlides = function () {
  // all operations for the slides with any resources
  // use the realIndex of the slide as resources are generated
  // based on the actual order of the presentation slides alone.

  // array of slideobjects that belongs to this controller. index starts from 1
  this.slides = [];

  // array of slide realindexes for easy access later, in image and html mode arrays
  this.slideModes.image = [];
  this.slideModes.html = [];

  var count = 0;

  var i, slide, size, slideConfig, errorScore, slideMode;

  // flag to note if imagemeta needs to be loaded. Loaded elsewhere for primary image mode.
  // This flag is only used for fallback imagemode.
  // If all html output has errorvalues below threshold, images are not loaded.
  var imageMetaRequired = false;
  // video slide patches.
  // video slides are not real slides. Having virtual slideIndexes and realIndexes and mappings to implement this.
  var realIndex,
    videoCount = 0;
  var videoSlidesHash = this.config.video_hash;
  this._mapIndexes(); // get index to real index mapping

  var indexMap = this.indexToRealIndex;

  var errorThreshold = this.AUTOVERIFICATION_ERROR_THRESHOLD;
  var percentageFailing = 0;
  var maxPercentageFailing = 100;

  //Constants for width and height if meta.js is disabled (fast player)
  var DISABLE_META_W = 638;
  var DISABLE_META_H = 479;

  // come back to this an optimize.
  // conversion version checks should not be happening this far down the flow
  if (
    this.conversionVersion === 2 &&
    typeof this.AUTOVERIFICATION_THRESHOLDS[this.algo] !== 'undefined'
  ) {
    errorThreshold = this.AUTOVERIFICATION_THRESHOLDS[this.algo];
    percentageFailing = this._percentageFailing(errorThreshold);
  }

  if (
    this.conversionVersion === 2 &&
    typeof this.MAX_PERCENTAGE_FAILING[this.algo] !== 'undefined'
  ) {
    maxPercentageFailing = this.MAX_PERCENTAGE_FAILING[this.algo];
  }

  for (i in indexMap) {
    if (indexMap.hasOwnProperty(i)) {
      // this check needed so that null properties are not read
      i = parseInt(i, 10);
      realIndex = indexMap[i];

      if (indexMap[i] === null) {
        // video embed slide
        slideMode = 'ytube_video';
        videoCount++;
      } else if (this.mode === 'iframe') {
        slideMode = 'iframe';
      } else if (i === 1 && this.config.image_ready) {
        slideMode = 'image';
        imageMetaRequired = true;
      } else if (this.mode === 'html' && !this.config.image_ready) {
        // pure html, ignore error values
        slideMode = 'html';
      } else if (this.mode === 'image') {
        // pure image. No html available
        slideMode = 'image';
      } else {
        // normal mode with html and image fallbacks
        if (
          this.conversionVersion === 2 &&
          percentageFailing > maxPercentageFailing
        ) {
          slideMode = 'image';
          imageMetaRequired = true;
          this.disableLoadingFonts = true;
        } else {
          errorScore = parseFloat(this.errorScores[i]);
          if (isNaN(errorScore)) {
            errorScore = this.DEFAULT_ERROR_SCORE;
          }
          if (errorScore > errorThreshold) {
            slideMode = 'image';
            imageMetaRequired = true;
          } else {
            slideMode = 'html';
          }
        }
      }

      // realIndex will be null meaning it is a video slide
      // then realIndex will be the value from the parent field of the hash.
      if (realIndex === null) {
        realIndex = videoSlidesHash[i].parent;
      }

      size = this.slideSizes[realIndex] || {};
      if (slideMode === 'html') {
        this.slideModes.html.push(realIndex);
      } else if (slideMode === 'image') {
        this.slideModes.image.push(realIndex);
      }
      var is_render_all_links = this.config.render_links === 'all';
      slideConfig = {
        ssid: this.config.id,
        realIndex: realIndex,
        index: i,
        type: this.mode,
        linkOffset: videoCount,
        slideMode: slideMode,
        indexGenerator: this._getIndexString,
        contentWidth: parseInt(size.width, 10) || DISABLE_META_W,
        contentHeight: parseInt(size.height, 10) || DISABLE_META_H,
        playerWidth: this.currentComponentSet.width,
        errorImageUrl: this.config.error_image_url,
        spinnerUrl: this.config.spinner_url,
        spinnerUrlFullscreen: this.config.spinner_url_fullscreen,
        playerType: this.config.player_type,
        stripped_title: this.config.stripped_title,
        timestamp: this.config.timestamp,
        ppt_location: this.config.ppt_location,
        is_private: this.config.is_private,
        is_render_all_links: is_render_all_links,
        hosted_in: this.config.hosted_in,
        show_image_player: this.config.show_image_player,
        isStartSlide: this.config.start_slide === i,
      };

      if (slideMode === 'html') {
        slideConfig.bucketLocation = this.config.bucket_location;
        slideConfig.availableSizes = this.availableBgSizes[realIndex];
        //delete
        //delete(this.htmlResourceSignatures[realIndex]);
      } else if (slideMode === 'image') {
        slideConfig.bucketLocation = this.config.image_bucket_location;
        slideConfig.availableSizes = this.config.disable_meta
          ? { 1024: [95] }
          : this.availableFallbackSizes[realIndex];
      } else if (slideMode === 'iframe') {
        slideConfig.html_location = this.config.html_location;
        slideConfig.iframe_id = this.config.iframe_id;
      }
      if (this.config.is_private) {
        if (slideMode == 'html') {
          if (
            this.htmlResourceSignatures &&
            this.htmlResourceSignatures[realIndex]
          ) {
            slideConfig.htmlResourceSignature =
              this.htmlResourceSignatures[realIndex].url;
          }
          slideConfig.privateImageSignatures =
            this.privateImageSignatures[realIndex];
        } else if (slideMode == 'image') {
          if (this.privateFallBackImageSignatures) {
            slideConfig.privateImageSignatures =
              this.privateFallBackImageSignatures[realIndex];
          }
        }
      }

      // Create a document/presentation/video slide
      // based on the type of slide
      if (this.config.player_type === 'document') {
        slide = new SSDocumentSlide(slideConfig);
        // document slide
      } else if (this.config.player_type === 'infographic') {
        slide = new SSInfographicSlide(slideConfig);
      } else if (this.config.player_type === 'html') {
        slide = new SSIframeSlide(slideConfig);
      } else {
        if (slideMode !== 'ytube_video') {
          slide = new SSPresentationSlide(slideConfig);
          // presentation slide
        } else {
          // video slide
          slideConfig.video_id = videoSlidesHash[i].video_id;
          slideConfig.current_video_count = videoCount;
          slideConfig.loading_message_partial =
            this.config.loading_message_partial;

          if (i === 1) {
            slideConfig.contentWidth = 728;
            slideConfig.contentHeight = 542;
          }
          slide = new SSVideoEmbedSlide(slideConfig);
        }
      } // if-else ending for config.player_type

      if (this.mode === 'image' && this.slideLinks[realIndex] !== undefined) {
        slide.updateResource('image', {
          linkData: this.slideLinks[realIndex] || {},
        });
      }

      this.slides[i] = slide;
      // delete(this.availableBgSizes[realIndex]);
      delete this.availableFallbackSizes[realIndex];
    } // if hasOwnProperty
  } //end forloop

  //image meta in fallback mode has been loaded in parallel. Now do the processing
  if (imageMetaRequired === true) {
    this.slidesCreated = true;
    this.fallbackMetaData && this.fallbackMetaHandler(this.fallbackMetaData);
  }
};

SSPlayerController.prototype._getIndexString = function (number, length) {
  var s = '' + number;
  var numberlen = s.length;
  var i;
  for (i = 0; i < length - numberlen; i++) {
    s = '0' + s;
  }
  return s;
};

SSPlayerController.prototype._getContainerSize = function () {
  this.currentComponentSet.width = this.currentComponentSet.container.width();
  this.currentComponentSet.height = this.currentComponentSet.container.height();
};

SSPlayerController.prototype.setDimensions = function (
  partial,
  isMobileRequest
) {
  var componentSet = this.currentComponentSet;

  this._getContainerSize();
  partial = partial || false;

  componentSet.viewHeight = componentSet.height;
  if (this.hasToolbar) {
    componentSet.viewHeight -= this.TOOLBAR_HEIGHT;
  }

  componentSet.slidedisplayer.setDimensions({
    width: componentSet.width,
    height: componentSet.viewHeight,
    partial: partial, // partial update only. do not pass to slides. hackish
  });
  if (!partial) {
    var dimensions = {
      height: componentSet.viewHeight,
      width: componentSet.width,
    };

    var compSet = this.currentComponentSet;
    $.each(
      ['toolbar', 'videobar', 'leadcta', 'shareScreen', 'lastScreen'],
      function (i, obj) {
        compSet[obj] &&
          typeof compSet[obj].setDimensions === 'function' &&
          compSet[obj].setDimensions(dimensions, isMobileRequest);
      }
    );
  }
};

/* For browsers where native full screen is not present and flash is being used
   Use the default toolbar which provides fullscreen action from within the flash player */
SSPlayerController.prototype.getSpecialSettingsForVideo = function () {
  var userAgent = navigator.userAgent.toLowerCase();
  // IE 11 now use mozilla and trident in ua, no msie anymore
  var isMoz =
    /mozilla/.test(userAgent) && !/(compatible|webkit|trident)/.test(userAgent);
  var isIELessThan8 =
    /msie/.test(userAgent) &&
    !/opera/.test(userAgent) &&
    document.documentMode &&
    document.documentMode < 8;
  var result = { ieLT8: isIELessThan8 },
    defaultToolbar = false;

  if (this.config.player_type === 'video') {
    if (isIELessThan8 && this.isEmbedAndIE()) {
      defaultToolbar = true;
    }
  } else {
    defaultToolbar = false;
  }
  result.defaultToolbar = defaultToolbar;
  return result;
};

SSPlayerController.prototype.repaint = function (isMobileRequest) {
  var userAgent = navigator.userAgent.toLowerCase();
  var isIE = /msie/.test(userAgent) && !/opera/.test(userAgent);

  // repaint gets called while switching to fullscreen mode in IE before components are created
  if (
    this.currentComponentSet.slidedisplayer === undefined ||
    (this.config.player_type === 'video' &&
      isIE &&
      this.currentComponentSet.videobar.fullscreen)
  ) {
    return;
  }
  this.setDimensions(true);
  this.setDimensions(false, isMobileRequest);
  this._repaintPrerenderedSlides();

  // Update all ytube embed iframe heights
  if (this.config.has_video) {
    var that = this;

    // Delay the resize to let window resize first
    setTimeout(function () {
      that.resizeVideoEmbeds();
    }, 250);
  }

  if (!this.config.show_image_player) {
    this.currentComponentSet.slidedisplayer._scrollTo(this.currentPosition);
  }
};

SSPlayerController.prototype._repaintPrerenderedSlides = function () {
  var prerenderedSlides =
    this.currentComponentSet.slidedisplayer.prerenderedSlides;
  var slideIndex;
  if (prerenderedSlides && prerenderedSlides.length > 0) {
    var i;
    for (i = 0; i < prerenderedSlides.length; i++) {
      slideIndex = prerenderedSlides[i];
      this.slides[slideIndex].show(true);
    }
  }
};

SSPlayerController.prototype.updateCurrentPosition = function (position) {
  if (this.slides && this.slides[position] !== undefined) {
    if (this.config.show_image_player) {
      this.currentComponentSet.slidedisplayer.currentPosition = position;
    }

    if (this.config.player_type === 'video') {
      return;
    }
    var toolbar = this.currentComponentSet.toolbar;

    toolbar && toolbar.updateCurrentPosition(position);

    var multimediaResource = this.multimediaResource;

    this.currentPosition = position;
    this.slides[position].painted = true;
    toolbar.updateProgressBar();
  }
};

SSPlayerController.prototype.displayLastScreen = function () {
  var that = this;
  if (
    this.config.player_type === 'video' &&
    this.currentComponentSet.videobar.fullscreen
  ) {
    return;
  }
  if (typeof this.currentComponentSet.lastScreen === 'undefined') {
    if (
      this.config.is_only_private ||
      (this.config.disable_lastscreen && !this.config.showProLastScreen) ||
      this.config.show_replay_screen
    ) {
      this.currentComponentSet.lastScreen = new SSReplayScreen({
        renderTo: this.currentComponentSet.container,
        settings: this.config.replayscreen,
      });
    } else {
      if (typeof this.currentComponentSet.lastScreen === 'undefined') {
        this.currentComponentSet.lastScreen = this._getShareScreen();
      }
      this.currentComponentSet.lastScreen =
        this.currentComponentSet.shareScreen;
    }
    $(this.currentComponentSet.lastScreen).bind('gotofirstslide', function () {
      $(that).trigger('gotofirstslide');
    });
  }

  var componentSet = this.currentComponentSet;
  componentSet.viewHeight = componentSet.height;
  if (this.hasToolbar) {
    componentSet.viewHeight -= this.TOOLBAR_HEIGHT;
  }
  this.currentComponentSet.lastScreen.show(
    {
      width: componentSet.width,
      height: componentSet.viewHeight,
    },
    this._isFullScreen(this.currentViewMode)
  );

  if (this.currentComponentSet.lastScreen.isProLastScreen) {
    $.slideshareEventManager.trackEvent('proLastscreen_shown');
  } else {
    $.slideshareEventManager.trackEvent('lastscreen_shown');
  }
};

SSPlayerController.prototype.hideLastScreen = function () {
  if (
    this.currentComponentSet.lastScreen &&
    this.currentComponentSet.lastScreen.isVisible
  ) {
    this.currentComponentSet.lastScreen.hide();
  }
};

SSPlayerController.prototype.hideShareScreen = function () {
  if (
    this.currentComponentSet.shareScreen &&
    this.currentComponentSet.shareScreen.isVisible
  ) {
    this.currentComponentSet.shareScreen.hide();
  }
};

SSPlayerController.prototype.displayShareScreen = function (config) {
  var that = this;
  var gaCategory = config.gaCategory;

  if (!gaCategory) {
    gaCategory = 'lastscreen_v1_'; // default
  }

  $.slideshareEventManager.trackEvent(gaCategory + 'share_cta_click');
  this._getShareScreen();

  this.currentComponentSet.shareScreen.showShareScreen({
    width: this.currentComponentSet.width,
    height: this.currentComponentSet.viewHeight,
    customizations: config.customizations,
  });

  // If modalShare exists, update its gaCategory.
  if (this.currentComponentSet.shareScreen.modalShare) {
    this.currentComponentSet.shareScreen.modalShare.gaCategory = gaCategory;
  } else {
    // Otherwise, instantiate it
    this.currentComponentSet.shareScreen.modalShare = new PlayerModalShare(
      {
        btnShare: '.action-btns-container .action-btn.share',
        parentEl: '.lastScreenContainer .lastScreen',
        el: '.lastScreenContainer .lastScreen .modal-share',
        gaCategory: gaCategory,
        authorId: this.config.author_id,
        isEmbed: this.isEmbed,
      },
      this.currentComponentSet.shareScreen
    );
  }

  this.currentComponentSet.shareScreen.modalShare.updateEmbed();
};

SSPlayerController.prototype.updateEmbedSizes = function () {
  var embed_sizes = this.config.embed_sizes;
  var aspectRatio = this.slideAspectRatio;
  if (
    this.config.player_type !== 'infographic' ||
    !embed_sizes ||
    !aspectRatio
  ) {
    return;
  }
  for (var i in embed_sizes.presets) {
    if (embed_sizes.presets.hasOwnProperty(i)) {
      var preset = embed_sizes.presets[i];
      preset.size.height = parseInt(preset.size.width * aspectRatio + 49, 10);
    }
  }

  if (this.currentComponentSet && this.currentComponentSet.shareScreen) {
    this.currentComponentSet.shareScreen.populateEmbedSizes();
  }
};

SSPlayerController.prototype._getShareScreen = function () {
  if (typeof this.currentComponentSet.shareScreen === 'undefined') {
    this.currentComponentSet.shareScreen = new SSLastScreen({
      renderTo: this.currentComponentSet.container,
      settings: this.config.lastscreen,
      slideshowId: this.config.id,
      embed_code: this.config.embed_code,
      iframe_url: this.config.iframe_url,
      iframe_code: this.config.iframe_code,
      embed_sizes: this.config.embed_sizes,
      wp_code: this.config.wp_code,
      lastScreenClass: this.config.lastScreenClass,
      disableRelated: this.config.disable_lastscreen,
      disableShare: this.config.disable_share,
      shareOptions: this.config.shareoptions,
      hostedIn: this.config.hosted_in,
      totalSlides: this.slideCount,
    });
  }
  return this.currentComponentSet.shareScreen;
};

SSPlayerController.prototype.loadFonts = function (batchIndex) {
  if (this.mode !== 'html' || this.disableLoadingFonts === true) {
    return;
  }
  var i = batchIndex;
  if (this.fontResources[batchIndex].status === 'initialized') {
    this.fontResources[batchIndex].load();
  }
};

SSPlayerController.prototype.getPrerenderSlideIndices = function (
  anchorIndex,
  isPreload
) {
  var startPrerender = anchorIndex - this.PRERENDER_COUNT;
  if (startPrerender < 1) {
    startPrerender = 1;
  }

  var endPrerender = anchorIndex + this.PRERENDER_COUNT;
  if (endPrerender > this.slideCount) {
    endPrerender = this.slideCount;
  }
  return [startPrerender, endPrerender];
};

SSPlayerController.prototype._load = function (anchorIndex, isPreload) {
  var userAgent = navigator.userAgent.toLowerCase();
  var isIE = /msie/.test(userAgent) && !/opera/.test(userAgent);

  if (this.config.player_type === 'video') {
    return;
  }
  anchorIndex = anchorIndex || this.config.start_slide;
  var i, slide;
  var that = this;

  this.loadFonts(Math.ceil(anchorIndex / this.FONT_BATCH_COUNT));

  if (!isPreload) {
    var startEndLimits = this.getPrerenderSlideIndices(anchorIndex, isPreload);
    var startPrerender = startEndLimits[0];
    var endPrerender = startEndLimits[1];

    for (i = startPrerender; i <= endPrerender; i++) {
      if (this.config.show_image_player) {
        this.slides[i].render();
      }
      this.slides[i].show();
      this.loadedSlides[i] = true;
    }

    // muting out hide for non-ie browsers for performance reasons.
    // IE however ignores styles after it has 31 styletags in dom. Hence we need to hide prerendered slides.
    // I look forward to the decade when I can say 'Goodbye IE. You will not be missed.'
    // We need it for ios devices as well , else safari tends to crash with css3 animation.
    if (
      (isIE || isIos()) &&
      typeof new_mobile_player === 'undefined'
    ) {
      var prerenderedSlides =
        this.currentComponentSet.slidedisplayer.prerenderedSlides;
      var slideIndex;
      // this could be simply refactored to hide for anchorindex since this is called only for presentations now.
      // leaving this functionality in case we want to unmute hide for docs later.
      if (prerenderedSlides) {
        for (i = 0; i < prerenderedSlides.length; i++) {
          slideIndex = prerenderedSlides[i];
          if (slideIndex < startPrerender || slideIndex > endPrerender) {
            slide = this.slides[slideIndex];
            slide.hide();
          }
        }
      }
      this.currentComponentSet.slidedisplayer.prerenderedSlides = [];
    }
    this.currentComponentSet.slidedisplayer.setPrerenderedSlides({
      start: startPrerender,
      end: endPrerender,
    });
  }

  // if eagerloading has been disabled
  //   Do not preload if we are on slide 1
  //   if the user moves to slide 2, which has been prerendered, being preloadinn
  if (
    this.config.disable_eagerload &&
    anchorIndex === this.config.start_slide
  ) {
    return;
  }

  // hold previous anchor index so we don't bind multiple handlers on pageload
  var previousPreloadAnchor = this.preloadAnchorIndex;
  this.preloadAnchorIndex = anchorIndex;

  var callbackForPreload = function () {
    that.preloadSlides();
  };

  // Use window.load event if required and if it hasn't been called yet
  if (this.config.preload_after_pageload && !this.pageLoadFired) {
    if (!previousPreloadAnchor) {
      // no previous window.load handler bound
      $(window).bind('load', callbackForPreload);
    }
  } else {
    clearTimeout(this.preloadTimeoutId);
    this.preloadTimeoutId = setTimeout(callbackForPreload, 2000);
  }
};

/**
 * Preloads slides from an anchor index. Is called via a setTimeout call or an event Callback
 * Accesses this.preloadAnchorIndex to ensure it only calls for the latest anchorIndex
 * Was initially implemented as closures but is lighter this way
 */
SSPlayerController.prototype.preloadSlides = function () {
  // if preload anchor isn't present, the last one has already been preloaded.
  if (!this.preloadAnchorIndex) {
    return;
  }
  var slideCount = this.PRELOAD_PRE_LIMIT + this.PRELOAD_POST_LIMIT + 1;
  var startSlideIndex = this.preloadAnchorIndex - this.PRELOAD_PRE_LIMIT;
  if (startSlideIndex < 1) {
    startSlideIndex = 1;
  }

  var endSlideIndex = startSlideIndex + slideCount - 1;
  if (endSlideIndex > this.slideCount) {
    endSlideIndex = this.slideCount;
  }

  // Batch font loading section
  var startFontBatch = Math.ceil(startSlideIndex / this.FONT_BATCH_COUNT);
  var endFontBatch = Math.ceil(endSlideIndex / this.FONT_BATCH_COUNT);
  for (var i = startFontBatch; i <= endFontBatch; i++) {
    this.loadFonts(i);
  }
  for (var i = startSlideIndex; i <= endSlideIndex; i++) {
    if (!this.loadedSlides[i]) {
      var slide = this.slides[i];
      if (this.config.show_image_player) {
        slide.render();
      }
      slide.load();
      this.loadedSlides[i] = true;
    }
  }
  // get rid of the anchor index so duplicate calls to this method do not execute
  delete this.preloadAnchorIndex;
};
/**
 * Preloads more slides if the slide load queue is empty
 * @todo move to load_queue class later and do the same for resources with prioritization as well
 * @note this will not load slides before current slide.
 * Eg if the user jumps to a slide directly on page load, previous slides will not be preloaded.
 */
SSPlayerController.prototype.preloadMoreIfIdle = function (index) {
  if (this.config.disable_eagerload) {
    return;
  }
  var loadingSlides = this.loadingSlides;
  var pos = loadingSlides.indexOf(index);
  if (pos > -1) {
    loadingSlides.splice(pos, 1);
  }
  if (!this.preloadAnchorIndex && loadingSlides.length < 2) {
    // preload more slides
    var lastIndex = this.loadedSlides.length + 1;
    if (lastIndex > this.realSlideCount) {
      return;
    }
    var that = this;
    setTimeout(function () {
      that._load(lastIndex, true);
    }, 0);
  }
};

SSPlayerController.prototype.play = function (index, force, source, opts) {
  // if player is not initialized and no index is passed in, set the playQueue to the slide requested to be played
  if (!this.initialized) {
    this.playQueue = index || 1;
    return;
  }
  if (index === undefined) {
    // if no index passed in and playQueue has a value, unset it and play that
    if (typeof this.playQueue !== 'undefined') {
      index = this.playQueue;
      delete this.playQueue;
    } else {
      index = 1;
    }
  }

  if (index < 1) {
    index = 1;
  }
  if (index > this.slideCount) {
    index = this.slideCount;
  }
  // if we are at same slide, no need to load again, unless force is true
  if (this.currentPosition === index && !force) {
    return;
  }
  if (this.config.player_type === 'video') {
    this.currentComponentSet.slidedisplayer.start();
    return;
  }
  if (opts && opts.updateBamboo && this.config.bambooleaf_enabled) {
    this.updateBambooProperties({ index: index });
  }
  $.slideshareEventManager.trigger('slidechanged', {
    index: index,
    force: force,
    source: source,
  });
};

SSPlayerController.prototype.updateBambooProperties = function (opts) {
  // Update href's on nav buttons
  var nextInd = opts.index < this.slideCount ? opts.index + 1 : 1;
  var prevInd = opts.index > 1 ? opts.index - 1 : 1;
  var key;
  for (key in this.componentSets) {
    var compset = this.componentSets[key];
    if (compset && compset.toolbar) {
      compset.toolbar.updateBamboo({
        nextInd: nextInd,
        prevInd: prevInd,
        nextHref: this.config.rel_slide_urls[nextInd - 1],
        prevHref: this.config.rel_slide_urls[prevInd - 1],
        nextTitle: this.config.slide_titles[nextInd - 1],
        prevTitle: this.config.slide_titles[prevInd - 1],
      });
    }
  }
};

/**
 * Resetting video slides' rendered property and content,
 * so that the slide is repainted and the video object
 * reloaded as a property of that slide.
 */
SSPlayerController.prototype._enableVideoReloading = function () {
  var slideindexes = this.slides;
  for (var i in slideindexes) {
    if (slideindexes.hasOwnProperty(i)) {
      if (
        slideindexes[i] &&
        slideindexes[i].config.slideMode === 'ytube_video'
      ) {
        slideindexes[i].emptySlide();
      }
    }
  }
};

SSPlayerController.prototype.switchNativeView = function (mode) {
  var that = this;

  if (mode === 'nativefullscreen') {
    var container = this.currentComponentSet.container;
    container.length && this.nativeFullScreen.request(container[0]);
  } else {
    this.nativeFullScreen.cancel();
  }

  if (this.componentSets[mode] === undefined) {
    this.componentSets[mode] = this.componentSets[this.currentViewMode];
  }

  this.currentComponentSet = this.componentSets[mode];
  this.currentViewMode = mode;

  //this is done to ensure that slide objects are created again
  //for each mode to tackle image resizing issues
  this.currentComponentSet.slidedisplayer.emptySlides();

  //configure toolbar fullscreen button and player background
  this.configureComponentsForNativeMode(mode);

  this._setModeForSlides(mode);
  this._load(this.currentPosition);
  this.updateCurrentPosition(this.currentPosition);
};

SSPlayerController.prototype._nativeFullScreenHandler = function (
  e,
  controller
) {
  var that = this;
  if (this.nativeFullScreen.isFullScreen()) {
    this.currentViewMode = 'nativefullscreen';
  } else {
    $.slideshareEventManager.trigger('leavefullscreen');
  }
  window.setTimeout(function () {
    that.repaint.call(that);
  }, 500);
};

SSPlayerController.prototype.nativeFullScreen = {
  request: function (container) {
    if (document.webkitFullscreenEnabled) {
      var isSafari =
        /safari/.test(navigator.userAgent.toLowerCase()) &&
        !/chrome/.test(navigator.userAgent.toLowerCase());
      //  The following code will work for chrome but not for safari,
      // for security reason apple didn't implement this, but the doc is not up to date.
      if (Element && Element.ALLOW_KEYBOARD_INPUT && !isSafari) {
        container.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      } else {
        container.webkitRequestFullScreen();
      }
    } else if (document.mozFullScreenEnabled) {
      container.mozRequestFullScreen();
    }
  },
  cancel: function () {
    if (document.webkitFullscreenEnabled) {
      document.webkitCancelFullScreen();
    } else if (document.mozFullScreenEnabled) {
      document.mozCancelFullScreen();
    }
  },
  fullScreenChangeEventName: function () {
    if (document.webkitFullscreenEnabled) {
      return 'webkitfullscreenchange';
    } else if (document.mozFullScreenEnabled) {
      return 'mozfullscreenchange';
    }
  },
  isFullScreen: function () {
    return document.webkitIsFullScreen || document.mozFullScreen;
  },
};

// Even if IE11 supports the fullscreen api there is still some issues with the embeds,
// so we are not adding IE11 to the valid browsers list for now.
SSPlayerController.prototype._isNativeFullScreenSupported = function () {
  var user_agent = navigator.userAgent.toLowerCase();
  var appName = navigator.appName.toLowerCase();
  var hasNativeSupport =
    document.webkitFullscreenEnabled || document.mozFullScreenEnabled;
  var isValidBrowser =
    /chrome/.test(user_agent) ||
    /firefox/.test(user_agent) ||
    /safari/.test(user_agent);
  // Support native fullscreen for Chrome, Safari and Firefox.
  return hasNativeSupport && isValidBrowser;
};

SSPlayerController.prototype.leaveFullScreen = function () {
  this.currentComponentSet.container.removeClass('fullscreen');
  if (this.currentComponentSet.videobar) {
    this.currentComponentSet.slidedisplayer.adjustSpinnerPosition(false);
  }
  this.currentComponentSet.lastscreen &&
    this.currentComponentSet.lastscreen.hide();
  if (
    this.currentViewMode === 'nativefullscreen' &&
    this.isNativeFullScreenSupported
  ) {
    this.switchNativeView('normal');
  } else if (!isIEAllVersion()) {
    if (this.config.player_type === 'video') {
      // If IE we need to close the window
      this.returnFromFullscreenForVideo();
    } else if (this.config.inpage_full_screen) {
      this.switchView('normal');
    }
  } else {
    try {
      window.close();
    } catch (exception) {}
  }
};

SSPlayerController.prototype.switchToFullScreen = function () {
  if (this.config.player_type === 'video') {
    this.currentComponentSet.container.addClass('fullscreen');
    this.goHtmlFullscreenForVideo();
  } else if (this.config.inpage_full_screen) {
    this.currentComponentSet.container.addClass('fullscreen');
    this.switchView('fullscreen');
  }
};

SSPlayerController.prototype.switchView = function (mode) {
  if (this.config.show_image_player) {
    if (mode === 'fullscreen') {
      this.currentViewMode = 'nativefullscreen';
      this.currentComponentSet.container.addClass('non-native-fullscreen');
    } else if (mode === 'normal') {
      this.currentViewMode = 'normal';
      this.currentComponentSet.container.removeClass('non-native-fullscreen');
      this.switchNativeView(this.currentViewMode);
    }
    this.configureComponentsForNativeMode(mode);
    this.repaint();
    $(window).trigger('resize');
    return;
  }

  // ignore if current mode is same as the requested modes
  if (mode === this.currentViewMode) {
    return;
  }

  if (this.config.has_video) {
    this._enableVideoReloading();
    $('[id*=ytube_player]').remove();
  }

  // deactivate current component
  this._deactivateComponentSet(this.currentViewMode);
  // create if the component set does not already exist
  if (this.componentSets[mode] === undefined) {
    this._createComponentSet(mode);
  }

  // active the new component set
  this._activateComponentSet(mode);
  // update slides with new componentSet details
  this._setModeForSlides(mode);
  // update dimensions based on new component set
  this.setDimensions();
  // force play the current slide, since the current position is already the same
  this.play(this.currentPosition, true);
  // do required loading and prerendering based on current position
  this._load(this.currentPosition);
  // update current position across all display elements like toolbar
  this.updateCurrentPosition(this.currentPosition);
};

SSPlayerController.prototype._activateComponentSet = function (mode) {
  var componentSet = this.componentSets[mode];
  var navigators = componentSet.navigators;

  this.currentComponentSet = componentSet;
  this.currentViewMode = mode;

  $.each(navigators, function (index, navigatorItem) {
    navigatorItem.activate();
  });
  if (mode === 'fullscreen' || this.config.is_fullscreen) {
    $(document).bind('keyup', this.exitFullScreenHandler);
    $(window).scrollTop(0);
  } else {
    $(document).unbind('keyup', this.exitFullScreenHandler);
    this.normalModeScrollPosition &&
      $(window).scrollTop(this.normalModeScrollPosition);
  }
};

SSPlayerController.prototype.exitFullScreenHandlerFactory = function () {
  var that = this;
  return function (e) {
    if (e.keyCode === 27) {
      // trigger a viewfullscreen on one of the navigators
      try {
        $.slideshareEventManager.trigger('leavefullscreen');
      } catch (exception) {}
    }
  };
};

SSPlayerController.prototype._deactivateComponentSet = function (mode) {
  // full screen mode component set gets destroyed on deactivation
  // it gets recreated each time, so based on current position, the neighboring slides get prerendered again
  // the normal mode component set remains muted
  var componentSet = this.componentSets[mode];
  var navigators = componentSet.navigators;

  $.each(navigators, function (index, navigatorItem) {
    navigatorItem.deactivate();
  });

  if (mode === 'fullscreen') {
    this._destroyComponentSet('fullscreen');
  }
  this.currentComponentSet = null;
  this.currentViewMode = null;
};

SSPlayerController.prototype._setModeForSlides = function (mode) {
  // need to think of the loading part of the slideview for different view sizes
  if (this.config.player_type !== 'video') {
    this.currentComponentSet.slidedisplayer.start({
      slides: this.slides,
      mode: mode,
      playerBgColor: this._getPlayerBgColor(mode),
    });
  }
  this.currentComponentSet.slidedisplayer._bindEvents();
};

SSPlayerController.prototype.getFullScreenUrl = function () {
  if (this.config.fullscreen_url) {
    return this.config.fullscreen_url + '/' + this.currentPosition;
  } else {
    return document.location;
  }
};

SSPlayerController.prototype.generateErrorDom = function (
  templateKey,
  dimensions
) {
  var cache_key =
    templateKey + '_' + dimensions.width + '_' + dimensions.height;

  // cache hit for error dom element
  var errorWrapper = this.cachedDomElements[cache_key];
  if (errorWrapper === undefined) {
    // cache miss
    var width = dimensions.width;
    var height = dimensions.height;

    var errorHeight = height / 3; // make the error message 1/3 height of screen estate, to a max of 200px
    errorHeight = errorHeight > width / 4 ? width / 4 : errorHeight;

    var borderRounding = parseInt(errorHeight / 20, 10);
    var sideMargin = 14;
    var topOffsetFactor = this.config.player_type === 'document' ? 4 : 2;
    var topMargin = (height - errorHeight) / topOffsetFactor;
    var fontSize = width / 25; // rudimentary best fit calculation for errormessage font size
    var imageMargin = errorHeight - sideMargin;

    errorWrapper = $(this.config[templateKey]);
    errorWrapper.css({
      height: height - topMargin,
      padding: topMargin + 'px ' + sideMargin + 'px 0',
    });

    var errorDiv = errorWrapper.children('div');
    errorDiv.css({
      '-moz-border-radius': borderRounding,
      '-webkit-border-radius': borderRounding,
      '-o-border-radius': borderRounding,
      '-ms-border-radius': borderRounding,
      'border-radius': borderRounding,
      height: errorHeight,
    });
    errorDiv.children('img').css({
      margin: sideMargin / 2,
      height: imageMargin,
      width: imageMargin,
    });
    errorDiv.children('div').css({
      left: imageMargin + sideMargin,
      padding: sideMargin + 'px 0 0 ' + sideMargin / 2 + 'px',
      'font-size': fontSize,
    });
    this.cachedDomElements[cache_key] = errorWrapper;
  }
  return $(errorWrapper).clone();
};

// Not using plugin's fullscreen as size manipulations after that doesn't work
// Manually setting size to full screen. Taking those values,
// and adjusting for the toolbar, seekbar etc.
SSPlayerController.prototype.goHtmlFullscreenForVideo = function () {
  // add own class to identify custom full screen
  this.currentComponentSet.slidedisplayer.container.addClass(
    'inPageFullscreen'
  );

  var videoPlayer = this.multimediaResource.videoPlayer;
  var videoDom = $(videoPlayer.getContainer());
  var parent = $(videoDom.parent());

  // Storing object size etc for coming back from fullscreen
  this.normalPosition = videoDom.css('position');
  this.normalZindex = videoDom.css('z-index');
  this.normalLeft = videoDom.css('left');
  this.normalTop = videoDom.css('top');
  this.normalPlayerWidth = parent.width();
  this.normalPlayerHeight = parent.height();
  this.toolbarPaddingLeft = parseInt($('.toolbar').css('padding-left'), 10);
  this.toolbarPadingRight = parseInt($('.toolbar').css('padding-right'), 10);
  // player size might be potentially different from the container's size. Rare case.
  // but just to be safe

  this.fullscreenHeight = $(window).height() - this.TOOLBAR_HEIGHT;
  this.fullscreenWidth = $(window).width();
  var that = this;

  parent.css({
    position: 'fixed',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    'z-index': this.VIDEO_FULLSCREEN_ZINDEX,
  });

  videoPlayer.resize(this.fullscreenWidth, this.fullscreenHeight);
  this.normalPlayerContainer = this.currentComponentSet.container;
  this.currentComponentSet.container = parent;

  /* Set css properties for toolbar, seekbar, volume control*/
  $(this.currentComponentSet.toolbar.container).css({
    'z-index': this.VIDEO_FULLSCREEN_ZINDEX,
    width:
      that.fullscreenWidth -
      (that.toolbarPaddingLeft + that.toolbarPadingRight),
    position: 'fixed',
    left: 0,
    bottom: 0,
  });
  $(this.currentComponentSet.toolbar.volumeControl.container).css({
    'z-index': this.VIDEO_FULLSCREEN_ZINDEX,
    position: 'fixed',
    bottom: 0,
  });
  $(this.currentComponentSet.videobar.container).css({
    'z-index': this.VIDEO_FULLSCREEN_ZINDEX,
    width: '100%',
    position: 'relative',
    left: 0,
    bottom: 0,
  });

  this.currentComponentSet.videobar.setDimensions({
    height: that.fullscreenHeight,
    width: that.fullscreenWidth,
    fullscreen: true,
  });

  // Since fullscreen action is manual, buttons have to be adjusted and binded to events
  var toolbarButtons = this.currentComponentSet.toolbar.getElements();
  toolbarButtons.fullScreen.hide();
  toolbarButtons.leaveFullScreen.show();
  videoPlayer.fullscreen = true;

  // On rebinding player to DOM, it takes small time to re-attach old listeners
  // without 0 time out, it fails to start playing again. *WEIRD*
  setTimeout(function () {
    videoPlayer.getState() === 'PLAYING' && videoPlayer.play(true);
  }, this.VIDEO_REINITIALISE_TIME);
  this.currentViewMode = 'fullscreen';
};

SSPlayerController.prototype.returnFromFullscreenForVideo = function () {
  // remove custom full screen selector
  this.currentComponentSet.slidedisplayer.container.removeClass(
    'inPageFullscreen'
  );

  var videoPlayer = this.multimediaResource.videoPlayer;
  var videoDom = $(videoPlayer.getContainer());
  var parent = $(videoDom.parent());

  var that = this;

  // restoring DOM element around video
  parent.css({
    position: 'relative',
    height: that.normalPlayerHeight,
    width: that.normalPlayerWidth,
    'z-index': that.normalZindex,
    left: that.normalLeft,
    top: that.normalTop,
  });

  // restoring video player
  videoPlayer.resize(this.normalPlayerWidth, this.normalPlayerHeight);
  this.currentComponentSet.container = this.normalPlayerContainer;

  // Since fullscreen action is manual, buttons have to be adjusted and binded to events
  var toolbarButtons = this.currentComponentSet.toolbar.getElements();
  toolbarButtons.leaveFullScreen.hide();
  toolbarButtons.fullScreen.show();

  // restoring toolbars
  var toolbar = $(this.currentComponentSet.toolbar.container);
  toolbar.css({
    position: 'relative',
    height: that.TOOLBAR_HEIGHT,
    width:
      that.normalPlayerWidth -
      (that.toolbarPaddingLeft + that.toolbarPadingRight),
    'z-index': that.normalZindex,
    left: that.normalLeft,
    top: that.normalTop,
    bottom: 0,
  });
  $(this.currentComponentSet.toolbar.volumeControl.container).css({
    position: 'relative',
    'z-index': that.normalZindex,
  });
  $(this.currentComponentSet.videobar.container).css({
    position: 'relative',
    height: that.MULTIMEDIABAR_HEIGHT,
    width: that.normalPlayerWidth,
    'z-index': that.normalZindex,
  });

  this.currentComponentSet.videobar.setDimensions({
    height: this.normalPlayerHeight,
    width: this.normalPlayerWidth,
  });
  videoPlayer.fullscreen = false;

  // On rebinding player to DOM, it takes small time to re-attach old listeners
  setTimeout(function () {
    videoPlayer.getState() === 'PLAYING' && videoPlayer.play(true);
  }, this.VIDEO_REINITIALISE_TIME);

  this.currentViewMode = 'normal';
};

SSPlayerController.prototype.isEmbedAndIE = function () {
  return isIEAllVersion() && this.config.hosted_in !== 'slideview';
};

SSPlayerController.prototype.deactivateToolbar = function () {
  this.currentComponentSet.toolbar.deactivate();
};

SSPlayerController.prototype.activateToolbar = function () {
  this.currentComponentSet.toolbar.activate();
};

SSPlayerController.prototype.isToolbarActive = function () {
  return this.currentComponentSet.toolbar.active;
};

// Update all youtube embed iframe heights (triggered when fullscreen toggled)
SSPlayerController.prototype.resizeVideoEmbeds = function () {
  if (
    this.currentComponentSet &&
    this.currentComponentSet.slidedisplayer &&
    this.currentComponentSet.slidedisplayer.container
  ) {
    var $slideContainer = this.currentComponentSet.slidedisplayer.container;
    var $videoSlides = $slideContainer.find('.ytube-container');
    if ($videoSlides.length > 0) {
      $videoSlides.height($slideContainer.height());
    }
  }
};

/* Returns true/false whether 'sunpass' should be displayed */
SSPlayerController.prototype.isValidNextSlideshowExperiment = function () {
  return (
    this.config.next_prev_experiment &&
    this.config.player_type === 'presentation'
  );
};

SSPlayerController.prototype.getAbTestValueByName = function (abTestName) {
  return (
    (window.slideshare_object && slideshare_object.nwayTestAssignments &&
      slideshare_object.nwayTestAssignments[abTestName]) ||
    'control'
  );
};

/*
 * Display the 'sunpass' CTA to load the next slideshow from related. All the
 * bindings are contained in this function because this is currently an
 * experiment.
 */
SSPlayerController.prototype.showNextSlideshowCTA = function () {
  var self = this;
  var jNextContainer = $('.j-next-container');
  // Only show 'sunpass' if related slideshows exist and sunpass is hidden
  if (this.isValidNextSlideshowExperiment()) {
      var nextSlideshow = {
        id: jNextContainer.attr('data-next-slideshare-id') || 0,
        thumb: jNextContainer.attr('data-next-slideshare-thumb') || '',
        title: jNextContainer.attr('data-next-slideshare-title') || '',
        url: jNextContainer.attr('data-next-slideshare-url') || '#'
      };

      this.config.nextSlideshow = nextSlideshow;
      var $currentContainer = this.currentComponentSet.container;

      if (this.getAbTestValueByName('stageDownloadCta') === 'stage_download_cta') {
        $('.stage-download-cta').hide();
      }

      if (this.getAbTestValueByName('downloadCtaEorDesktop') === 'control') {
        var $el = $currentContainer.find('.j-next-container');
        var $timer = $el.find('.j-timer-count');
        var remainingSeconds = 2;

        // Countdown timer that then redirects to the next slideshow
        var countOneSecond = function() {
          if(remainingSeconds === 0) {
            clearInterval(self.countDown);
            $.slideshareEventManager.trackEvent('next_slideshow_cta_loaded');
            self.goToNextSlideshow();
          }

          if(remainingSeconds >= 0) {
            $timer.text(remainingSeconds);
            remainingSeconds--;
          }
        };

        $el.find('.j-next-url').on('click', function() {
          $.slideshareEventManager.trackEvent('next_slideshow_cta_loaded');
          self.goToNextSlideshow();
        });

        $el.find('.j-next-cancel').on('click', function() {
          self.hideNextSlideshowCTA();
        });

        // Activates and updates CTA with next slideshow info
        if($el.length) {
          $el.find('.j-next-thumb').attr({
            alt: nextSlideshow.title,
            src: nextSlideshow.thumb
          });
          $el.find('.j-next-title').text(nextSlideshow.title);
          $timer.text(remainingSeconds + 1);
          $el.addClass('active');

          this.countDown = setInterval(countOneSecond, 1000);
          $.slideshareEventManager.trackEvent('next_slideshow_cta_opened');
          $(document).bind('keyup.next_slideshow',
            $.proxy(self.nextSlideshowKeypressHandler, self));
        }
      } else {
        var $el = $currentContainer.find('.next-container');
        $el.addClass('active');
        amplitude.getInstance().logEvent('end-of-reading-shown-desktop');
      }

      // Cancel sunpass if any toolbar action btns are clicked
      $('.ssActions .j-tooltip').bind('click.cancel_next_slideshow', function() {
        self.hideNextSlideshowCTA();
      });
  }
};

/*
 * ESC cancels loading next slide and clears the redirect count down.
 * This exists so we can unbind the ESC key when the CTA is hidden.
 * Otherwise, we would have to use a global var.
 *
 * Enter key (keyCode 13) redirects to the next slide.
 */
SSPlayerController.prototype.nextSlideshowKeypressHandler = function (e) {
  // ESC
  if (e.keyCode === 27) {
    this.hideNextSlideshowCTA();
  }

  // ENTER
  if (e.keyCode === 13) {
    $.slideshareEventManager.trackEvent('next_slideshow_cta_loaded');
    this.goToNextSlideshow();
  }
};

SSPlayerController.prototype.goToNextSlideshow = function () {
  $.slideshareEventManager.trigger(
    'updateNextSlideshowCookie',
    this.config.nextSlideshow.id
  );

  // Fix for IE browsers
  if (!window.location.origin) {
    window.location.origin =
      window.location.protocol +
      '//' +
      window.location.hostname +
      (window.location.port ? ':' + window.location.port : '');
  }

  var position = !this.config.next_slideshow_pos
    ? 1
    : parseInt(this.config.next_slideshow_pos, 10) + 1;
  var redirectUrl =
    window.location.origin +
    this.config.nextSlideshow.url +
    '?next_slideshow=' +
    position;

  window.location.href = redirectUrl;
};

/*
* Hide the 'sunpass' CTA. All unbinds are in this function since this is an
* experiment. Will move them out when this is used for all slideview types.
*/
SSPlayerController.prototype.hideNextSlideshowCTA = function() {
  var $currentContainer = this.currentComponentSet.container;

  if (this.getAbTestValueByName('stageDownloadCta') === 'stage_download_cta') {
    $('.stage-download-cta').show();
  }

  if (this.getAbTestValueByName('downloadCtaEorDesktop') === 'download_cta_eor') {
    var $el = $currentContainer.find('.next-container');
    $el.removeClass('active');
  } else {
    // Only hide if 'sunpass' is shown
    if($('.j-next-container').is(':visible')) {
      $.slideshareEventManager.trackEvent('next_slideshow_cta_closed');
      clearInterval(this.countDown);
      var $el = $currentContainer.find('.j-next-container');
  
      $el.removeClass('active');
      $el.find('.j-next-url, .j-next-cancel').unbind('click');
    }
  }

  // Unbind click handlers
  $(document).unbind('keyup.next_slideshow');
  $('.ssActions .j-tooltip').unbind('click.cancel_next_slideshow');
};

/**
 * updateProgressBar() will update the slideshow progress bar above the toolbar
 */
SSPlayerController.prototype.updateProgressBar = function () {
  if (this.$slidesLoadedBar.length === 0) {
    return;
  }

  var progress = (this.currentPosition / this.slideCount) * 100;
  this.$slidesLoadedBar.width(progress + '%');
};

export default SSPlayerController;
